import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { user, loading } = useAuth();
  
  // If still loading auth state, show nothing
  if (loading) {
    return <div>Loading...</div>;
  }
  
  // If no user is logged in, redirect to login page
  if (!user) {
    return <Navigate to="/login" />;
  }
  
  // If roles are specified, check if user has an allowed role
  if (allowedRoles.length > 0) {
    const hasAllowedRole = allowedRoles.includes(user.role);
    if (!hasAllowedRole) {
      // User doesn't have the required role, redirect to home
      return <Navigate to="/home" />;
    }
  }
  
  // User is authenticated (and has allowed role if specified)
  return children;
};

export default ProtectedRoute;